export const rules = {
    nationality: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
};
